
import axios from 'axios'
import VueCookies from 'vue-cookies'

export default {
  get (data) {
    // limit
    const limit = data.limit ? '&limit=' + data.limit : ''
    // search
    const search = data.search ? '&s=' + data.search + '&s_field=name,email' : ''
    // pagination
    const page = data.page ? data.page : 1
    return axios.get(process.env.API_ENDPOINT + '/role?token=' + VueCookies.get('token') + '&page=' + page + search + limit)
  },
  create (data) {
    return axios.post(process.env.API_ENDPOINT + '/role?token=' + VueCookies.get('token'), data)
  },
  show (id) {
    return axios.get(process.env.API_ENDPOINT + '/role/' + id + '?token=' + VueCookies.get('token'))
  },
  update (data, id) {
    return axios.post(process.env.API_ENDPOINT + '/role/' + id + '?token=' + VueCookies.get('token'), data)
  },
  delete (id) {
    return axios.delete(process.env.API_ENDPOINT + '/role/' + id + '?token=' + VueCookies.get('token'))
  }
}



// WEBPACK FOOTER //
// ./src/store/api/roles.js